
import airbnbLogo from "./airbnb.png";
import alibabaLogo from "./alibaba.png";
import amazonLogo from "./amazon.png";
import amdLogo from "./amd.png";
import appleLogo from "./apple.png";
import arkLogo from "./ark.png";
import bitcoinLogo from "./bitcoin.png";
import coinbaseLogo from "./coinbase.png";

const logo = {
  airbnb: airbnbLogo,
  alibaba: alibabaLogo,
  amazon: amazonLogo,
  amd: amdLogo,
  apple: appleLogo,
  ark: arkLogo,
  bitcoin: bitcoinLogo,
  coinbase: coinbaseLogo
};
export default logo;